import { InputNumber as InpNumber, InputNumberProps } from "antd";
import { Form } from "react-bootstrap";

interface NumberInputPropsI extends InputNumberProps {
   label?: string | JSX.Element | JSX.Element[];
   classNameLabel?: string;
   text?: string;
   classNameText?: string;
   controlId?: string;
   classNameContainer?: string;
}

const InputNumber = ({
   label, classNameLabel, text,
   classNameText, controlId, classNameContainer,
   ...rest
}: NumberInputPropsI) => {
   return (
      <Form.Group controlId={controlId} className={classNameContainer}>
         <Form.Label className={classNameLabel}>
            {label}
         </Form.Label>
         <InpNumber {...rest}/>
         <Form.Text className={classNameText}>
            {text}
         </Form.Text>
      </Form.Group>
   )
}
export default InputNumber;
